/* eslint-disable react/require-default-props */
import { Component } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { Modal } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { intlShape, DetailsItem, showSuccess } from "lcm-iot-commons";

type Props = {
  show?: boolean;
  titleText?: string;
  contextBodyText?: string;
  username?: string;
  password?: string;
  onClose?: $TSFixMeFunction;
  intl?: intlShape;
};

class TechnicalUserModal extends Component<Props> {
  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    /* istanbul ignore next */
    this.onCopyPassword = this.onCopyPassword.bind(this);
  }

  onCopyPassword() {
    const { intl } = this.props;
    showSuccess(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      intl.formatMessage({
        id: "technical_user_modal.password_copy_successful",
      }),
    );
  }

  render() {
    const {
      titleText,
      username,
      password,
      intl,
      show,
      contextBodyText,
      onClose,
    } = this.props;

    return (
      <Modal
        show={show}
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        onHide={onClose}
        restoreFocus={false}
        backdrop="static"
      >
        <Modal.Header data-testid="modal-header" closeButton>
          <Modal.Title>
            <div className="space-after" />
            {titleText}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{contextBodyText}</p>
          <p>
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            {intl.formatMessage({
              id: "technical_user_modal.security_message",
            })}
          </p>
          <br />
          <div className="modal-details">
            <DetailsItem
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              label={intl.formatMessage({
                id: "technical_user_modal.username_title",
              })}
            >
              <span id="username">{username}</span>
            </DetailsItem>
            <DetailsItem
              className="password-padding-bottom"
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              label={intl.formatMessage({
                id: "technical_user_modal.password_title",
              })}
            >
              <div className="password-style">
                <div className="password-overflow">
                  <span id="password">{password}</span>
                </div>
                <span style={{ width: "10px" }} />
                {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
                <CopyToClipboard text={password} onCopy={this.onCopyPassword}>
                  <div>
                    <span
                      id="copy-password"
                      className="icon lcm-iot-icon-clipboard icon-style"
                    />
                  </div>
                </CopyToClipboard>
              </div>
            </DetailsItem>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-group">
            <button
              id="button-close"
              type="button"
              className="btn btn-primary"
              onClick={onClose}
            >
              {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
              {intl.formatMessage({ id: "button.close" })}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(TechnicalUserModal);
